<template>
  <div class="mb-9" v-if="addOn">
    <h4>{{ addOn.name + ' : ' + (addOn.quantity || 0) }}</h4>
    <p class="font12 mb-1">{{ addOn.description }}</p>
    <div v-if="total">
      <p class="font12 text-end mb-1 component__des">
        {{ `${currentUsage}` }} of
        {{ `${total} ${unit} ${entityName}` }}
      </p>
      <v-progress-linear height="25" :value="progressBarValue" />
    </div>
  </div>
</template>
<script>
import config from '../../../../config';
import FileSizeConverter, { bytesInKB } from '@/helpers/FileSizeConverter';
export default {
  name: 'AddOnComponent',
  props: ['addOn', 'available'],
  data() {
    return {
      unit: '',
      entityName: '',
      // Current used storage or project
      used: 0,
      // Total available storage or project
      total: ''
    };
  },
  computed: {
    progressBarValue() {
      const PERCENTAGE_MULTIPLIER = 100;
      let currentUsage = this.used;

      // For Data Pack progress bar
      if (this.addOn?.handle === config?.dataPackHandle) {
        const bytesInGB = bytesInKB * bytesInKB;
        // Size conversion of totalVolume coming in KB from BE to GB
        currentUsage = currentUsage / bytesInGB;
      }

      return (currentUsage / this.total) * PERCENTAGE_MULTIPLIER;
    },
    currentUsage() {
      // For Data Pack progress bar
      if (this.addOn?.handle === config?.dataPackHandle) {
        // Size conversion of totalVolume coming in KB from BE
        return FileSizeConverter(this.used * bytesInKB);
      }

      return this.used;
    }
  },
  mounted() {
    this.getCurrentUsage();
  },
  methods: {
    async getCurrentUsage() {
      try {
        if (this.addOn?.handle === config?.discoveryPackHandle) {
          this.entityName = 'Projects';
          this.total = this.available.projects;
          this.getProjectsCount();
        } else if (this.addOn?.handle === config?.dataPackHandle) {
          this.unit = 'GB';
          this.total = this.available.storage;
          this.getStorageVolume();
        }
      } catch (err) {
        this.snackbar('error', err);
      }
    },

    // To get total used storage of email & vault data
    async getStorageVolume() {
      try {
        const vaultVolume = await this.$services.vaultData.getVaultVolume();
        const emailVolume = await this.$services.search.getEmailVolume();
        const vaultVolumeDetails = this.parseResponse(vaultVolume);
        const emailVolumeDetails = this.parseResponse(emailVolume);

        // Ignore email size coming under vault volume details
        delete vaultVolumeDetails?.[0]?.['o365_email'];

        // Adding volume of all connectors other than o365_email
        const totalVaultVolume = Object.values(
          vaultVolumeDetails?.[0] || {}
        ).reduce((total, curr) => total + (curr || 0), 0);

        // totalVolume = totalVaultVolume + email_volume
        const totalVolume =
          totalVaultVolume + (+emailVolumeDetails?.[0]?.['email_volume'] || 0);
        this.used = totalVolume;
      } catch (err) {
        this.snackbar('error', err);
      }
    },

    // To get how many projects are created
    async getProjectsCount() {
      try {
        const response = await this.$services.project.getActiveDiscoveryProjectsCount();
        const parsedResponse = this.parseResponse(response);
        this.used = parsedResponse?.[0] || 0;
      } catch (err) {
        this.snackbar('error', err);
      }
    }
  }
};
</script>
<style scoped>
.component__des {
  font-weight: 600;
}
</style>
